'use client';

import moment from 'moment';
import LoginForm from '../ui/login-form';
import { Suspense } from 'react';
import {
  LockClosedIcon,
  ShieldCheckIcon,
  BuildingOfficeIcon,
  ServerIcon,
  CheckCircleIcon
} from '@heroicons/react/24/outline';

export default function Page() {
  const isDecember = moment().month() === 11;
  const isApril = moment().month() === 3;

  return (
    <Suspense fallback={<div className="min-h-screen bg-slate-950 flex items-center justify-center text-white text-sm font-bold">Carregando...</div>}>
      <main className="min-h-screen w-full bg-slate-950 flex flex-col lg:flex-row relative overflow-hidden">
        {/* Efeitos Sazonais Mantidos */}
        {isDecember && (
          <div className="snowflakes" aria-hidden="true">
            <div className="snowflake">❅</div>
            <div className="snowflake">❆</div>
            <div className="snowflake">❅</div>
            <div className="snowflake">❆</div>
            <div className="snowflake">❅</div>
            <div className="snowflake">❆</div>
          </div>
        )}

        {isApril && (
          <div className="snowflakes" aria-hidden="true">
            <div className="snowflake">🐰</div>
            <div className="snowflake">🐰</div>
            <div className="snowflake">🐰</div>
            <div className="snowflake">🐰</div>
          </div>
        )}

        {/* Elementos Decorativos de Fundo Exclusivos para Mobile */}
        <div className="lg:hidden absolute top-0 left-1/2 -translate-x-1/2 w-80 h-80 sm:w-[500px] sm:h-[500px] bg-blue-600/25 rounded-full blur-3xl pointer-events-none" />
        <div className="lg:hidden absolute bottom-0 right-0 w-80 h-80 sm:w-[500px] sm:h-[500px] bg-indigo-600/25 rounded-full blur-3xl pointer-events-none" />

        {/* LADO ESQUERDO: Painel Interno da Clínica Sólido no Desktop (Sem degradê) */}
        <div className="hidden lg:flex lg:w-1/2 relative flex-col justify-between p-12 bg-slate-950 border-r border-slate-800/80">
          {/* Header Interno Desktop */}
          <div className="relative z-10">
            <div className="flex items-center gap-3">
              <div className="p-3 bg-white/5 rounded-2xl border border-white/10 shadow-xl">
                <span className="text-sm font-extrabold text-white tracking-wider uppercase">EVK</span>
              </div>
            </div>
          </div>

          {/* Conteúdo Corporativo / Interno Desktop */}
          <div className="relative z-10 space-y-6 max-w-lg">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-slate-900 border border-slate-800 text-blue-400 text-xs font-bold uppercase tracking-wider">
              <LockClosedIcon className="w-4 h-4 text-blue-400" />
              <span>Ambiente Privado de Uso Interno</span>
            </div>

            <h1 className="text-4xl font-black text-white leading-tight tracking-tight">
              Sistema Evolution Kids
            </h1>

            <p className="text-sm text-slate-400 leading-relaxed">
              Acesso restrito ao corpo clínico, médicos, especialistas e colaboradores autorizados da unidade.
            </p>

            {/* Pílulas de Informações do Sistema */}
            <div className="grid grid-cols-2 gap-3 pt-2">
              <div className="flex items-center gap-2.5 p-3.5 rounded-xl bg-slate-900/80 border border-slate-800 text-xs font-semibold text-slate-300">
                <BuildingOfficeIcon className="w-4 h-4 text-blue-400 shrink-0" />
                <span>Uso Exclusivo da Clínica</span>
              </div>
              <div className="flex items-center gap-2.5 p-3.5 rounded-xl bg-slate-900/80 border border-slate-800 text-xs font-semibold text-slate-300">
                <ShieldCheckIcon className="w-4 h-4 text-emerald-400 shrink-0" />
                <span>Acesso Seguro</span>
              </div>
              <div className="flex items-center gap-2.5 p-3.5 rounded-xl bg-slate-900/80 border border-slate-800 text-xs font-semibold text-slate-300">
                <ServerIcon className="w-4 h-4 text-amber-400 shrink-0" />
                <span>Servidor Local Ativo</span>
              </div>
              <div className="flex items-center gap-2.5 p-3.5 rounded-xl bg-slate-900/80 border border-slate-800 text-xs font-semibold text-slate-300">
                <CheckCircleIcon className="w-4 h-4 text-indigo-400 shrink-0" />
                <span>Sessão Criptografada</span>
              </div>
            </div>
          </div>

          {/* Footer Institucional Interno Desktop */}
          <div className="relative z-10 text-xs text-slate-500 flex items-center justify-between border-t border-slate-800/80 pt-6">
            <span>Evolution Kids - Sistema Corporativo</span>
            <span className="font-mono text-slate-500">v1.2</span>
          </div>
        </div>

        {/* LADO DIREITO: Form de Login EVK (Mobile & Desktop com Degradê no Mobile) */}
        <div className="w-full lg:w-1/2 min-h-screen flex flex-col justify-between p-6 sm:p-12 relative z-10 bg-gradient-to-br from-slate-950 via-slate-900 to-blue-950  backdrop-blur-md">
          {/* Header Exclusivo Mobile */}
          <div className="flex lg:hidden items-center justify-between pt-2 pb-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-400/20 text-blue-300 text-[11px] font-bold uppercase tracking-wider backdrop-blur-md">
              <LockClosedIcon className="w-3.5 h-3.5 text-blue-400" />
              <span>Evolution Kids • Acesso Interno</span>
            </div>
          </div>

          {/* Container do Form Centralizado */}
          <div className="w-full max-w-md mx-auto my-auto py-4">
            <LoginForm />
          </div>

          {/* Footer Exclusivo Mobile */}
          <div className="flex lg:hidden items-center justify-between text-[11px] text-slate-400 pt-4 border-t border-slate-800/60">
            <span>Evolution Kids Corporativo</span>
            <span className="font-mono text-slate-400">v1.2</span>
          </div>
        </div>
      </main>
    </Suspense>
  );
}